export const shouldRenderDocumentAutomaticCaptureSettingsJustInBrazilianFlow = ({ templateTheme, ...rest }) => {
  return templateTheme?.isBrazilianFlow !== false;
};
